import React, { useEffect, useState } from "react";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import "./style/contactus.css";
import Leftnavigation from "./Leftnavigation";

const Contactform = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await fetch(
          "https://gptkpm.in/backend/contactus/display.php"
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setContacts(data.contacts || []);
      } catch (err) {
        setError("Failed to fetch data. Please try again later.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchContacts();
  }, []);

  return (
    <div className="admin-panel">
        <Header/>
        <Leftnavigation/>
        <div className="contact-form-data">
      <h2>Submitted Contact Forms</h2>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : contacts.length > 0 ? (
        <table className="contact-table">
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Message</th>
              <th>Submitted At</th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((contact) => (
              <tr key={contact.id}>
                <td>{contact.first_name}</td>
                <td>{contact.last_name}</td>
                <td>{contact.email}</td>
                <td>{contact.phone}</td>
                <td>{contact.message}</td>
                <td>{contact.created_at}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No contact forms submitted yet.</p>
      )}
      </div>
      <Footer/>
    </div>
  );
};

export default Contactform;
